import * as styleRefs from '../seek-charts/styles/textStyles.css';

export function useTextStyles() {
  return styleRefs;
}
